import { QueryFunction } from 'react-query';
import { get } from 'src/api';
import { AssistantChatMessage } from './types';

const getMessageList = (): [string[], QueryFunction<AssistantChatMessage[]>] => [
  ['assistantMessages'],
  async () => {
    const result = await get<AssistantChatMessage[]>('/sal-assistant/messages');
    return Array.isArray(result) ? result : [];
  },
];

export { getMessageList };
